<div class="container" [formGroup]="forms">
  <h3 class="title">Venda e locação</h3>
  <div class="form-container">
    <div class="form-toggle">
      <app-slide-toggle
        (sendToggle)="toggleForm($event, 'sale')"
      ></app-slide-toggle>
      <span>Vender imóvel</span>
    </div>
    <div class="form-content" *ngIf="forms.get('sale').value">
      <div class="form-control">
        <div class="input-box form-flex-50">
          <app-input
            class="input-control"
            id="salePrice"
            [label]="'Preço de venda *'"
            maxlength="14"
            [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
            formControlName="salePrice"
            [messageError]="'Campo obrigatório'"
            [isPrice]="true"
            [placeholder]="''"
          ></app-input>
        </div>
        <div class="input-box form-flex-50">
          <app-input
            class="input-control"
            id="commission"
            [label]="'% de comissão'"
            maxlength="4"
            [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
            formControlName="commission"
            [messageError]="'Campo obrigatório'"
            [placeholder]="''"
            maskInput="0*"
            separatorLimit="99"
            suffixInput=" %"
          ></app-input>
        </div>
      </div>
      <div class="form-control">
        <div class="form-flex-50 check-form">
          <p>O imóvel está quitado?</p>
          <div class="check-control two-check">
            <lib-input-checkbox
              id="sale-settled-chk-f"
              name="sale-settled-false"
              label="Sim"
              formControlName="settled"
              (click)="toggleDebt(true)"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-20"
              id="sale-debt-chk-t"
              name="sale-debt-true"
              label="Não"
              formControlName="notSettled"
              (click)="toggleDebt(false)"
            ></lib-input-checkbox>
          </div>
        </div>
        <div class="input-box form-flex-50">
          <app-input
            class="input-control"
            id="debt"
            [label]="'Saldo devedor'"
            maxlength="14"
            [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
            formControlName="debt"
            [messageError]="'Campo obrigatório'"
            [isPrice]="true"
            [placeholder]="''"
          ></app-input>
        </div>
      </div>
      <div class="form-control">
        <div class="form-flex-50 check-form">
          <p>O imóvel possui renda?</p>
          <div class="check-control two-check">
            <lib-input-checkbox
              id="sale-income-chk-t"
              name="sale-income-true"
              label="Sim"
              formControlName="profitable"
              (click)="toggleIncome(true)"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-20"
              id="sale-income-chk-f"
              name="sale-income-false"
              label="Não"
              formControlName="notProfitable"
              (click)="toggleIncome(false)"
            ></lib-input-checkbox>
          </div>
        </div>
        <div class="input-box form-flex-50">
          <app-input
            class="input-control"
            id="income"
            [label]="'Renda do imóvel'"
            maxlength="14"
            [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
            formControlName="income"
            [messageError]="'Campo obrigatório'"
            [isPrice]="true"
            [placeholder]="''"
          ></app-input>
        </div>
      </div>
      <div class="form-control">
        <div class="check-form">
          <p>Outros detalhes</p>
          <div class="check-control four-check">
            <lib-input-checkbox
              id="sale-details-chk-exchange"
              name="sale-details-exchange"
              label="Aceita permuta"
              formControlName="saleD1"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-10"
              id="sale-details-chk-division"
              name="sale-details-division"
              label="Aceita parcelamento"
              formControlName="saleD2"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-10"
              id="sale-details-chk-financing"
              name="sale-details-financing"
              label="Aceita financiamento"
              formControlName="saleD3"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-10"
              id="sale-details-chk-proposal"
              name="sale-details-proposal"
              label="Aceita proposta"
              formControlName="saleD4"
            ></lib-input-checkbox>
          </div>
        </div>
      </div>
      <div class="form-control">
        <app-input
          class="form-flex-100"
          label="Captador de venda"
          placeholder="Rafael Talaricano / Lopes Itaim"
          maxlength="100"
        ></app-input>
      </div>
    </div>
  </div>
  <div class="form-container">
    <div class="form-toggle">
      <app-slide-toggle
        (sendToggle)="toggleForm($event, 'rent')"
      ></app-slide-toggle>
      <span>Alugar imóvel</span>
    </div>
    <div class="form-content" *ngIf="forms.get('rent').value">
      <div class="form-control">
        <div class="input-box form-flex-50">
          <app-input
            class="input-control"
            id="rentPrice"
            [label]="'Preço de locação *'"
            maxlength="14"
            [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
            formControlName="rentPrice"
            [messageError]="'Campo obrigatório'"
            [isPrice]="true"
            [placeholder]="''"
          ></app-input>
        </div>
      </div>
      <div class="form-control">
        <div class="check-form">
          <p>Outros detalhes</p>
          <div class="check-control three-check">
            <lib-input-checkbox
              id="rent-details-chk-admin-inc"
              name="rent-details-admin-inc"
              label="Administrado por empresa"
              formControlName="rentD1"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-10"
              id="rent-details-chk-bail"
              name="rent-details-bail"
              label="Fiança gratuita"
              formControlName="rentD2"
            ></lib-input-checkbox>
            <lib-input-checkbox
              class="left-m-10"
              id="rent-details-chk-proposal"
              name="rent-details-proposal"
              label="Aceita proposta"
              formControlName="rentD3"
            ></lib-input-checkbox>
          </div>
        </div>
      </div>
      <div class="form-control">
        <app-input
          class="form-flex-100"
          label="Captador de venda"
          placeholder="Rafael Talaricano / Lopes Itaim"
          maxlength="100"
        ></app-input>
      </div>
    </div>
  </div>
</div>
